import { theme as antdTheme } from 'antd';

export const themeTokens = {
    colorPrimary: '#2563EB',
    colorSuccess: '#16A34A',
    colorWarning: '#F59E0B',
    colorError: '#DC2626',
    colorInfo: '#2563EB',
    colorBgLayout: '#F8FAFC',
    borderRadius: 6,
    fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, sans-serif'
};

// Monokai Pro palette — bold, slightly warm dark surfaces with pastel accents.
// Keep these canonical: main.scss and CommandPalette/index.scss mirror the
// surface + border values so chrome matches antd components under the same theme.
export const monokai = {
    bg: '#221F22',
    bgElevated: '#2D2A2E',
    bgContainer: '#2D2A2E',
    bgSubtle: '#403E41',
    border: '#5B595C',
    borderSubtle: '#403E41',
    text: '#FCFCFA',
    textSecondary: '#C1C0C0',
    textMuted: '#727072',
    pink: '#FF6188',
    orange: '#FC9867',
    yellow: '#FFD866',
    green: '#A9DC76',
    cyan: '#78DCE8',
    purple: '#AB9DF2'
};

export const darkTokens = {
    colorPrimary: monokai.purple,
    colorLink: monokai.cyan,
    colorSuccess: monokai.green,
    colorWarning: monokai.orange,
    colorError: monokai.pink,
    colorInfo: monokai.cyan,
    colorBgLayout: monokai.bg,
    colorBgContainer: monokai.bgContainer,
    colorBgElevated: monokai.bgSubtle,
    colorBorder: monokai.border,
    colorBorderSecondary: monokai.borderSubtle,
    colorText: monokai.text,
    colorTextSecondary: monokai.textSecondary,
    colorTextTertiary: monokai.textMuted,
    colorTextQuaternary: monokai.textMuted,
    borderRadius: 6,
    fontFamily: themeTokens.fontFamily
};

export const themeConfig = {
    token: themeTokens,
    algorithm: [antdTheme.compactAlgorithm],
    components: {
        Menu: {
            itemSelectedBg: '#EFF6FF',
            itemSelectedColor: '#2563EB'
        },
        Table: {
            headerBg: '#F8FAFC',
            headerColor: '#475569'
        },
        // Make the active segment clearly stand out in the light theme
        // (the default white-on-light-grey is too subtle).
        Segmented: {
            trackBg: '#EEF2F7',
            itemSelectedBg: '#FFFFFF',
            itemSelectedColor: themeTokens.colorPrimary,
            itemColor: '#475569'
        }
    }
};

export const darkThemeConfig = {
    token: darkTokens,
    algorithm: [antdTheme.darkAlgorithm, antdTheme.compactAlgorithm],
    components: {
        Layout: {
            headerBg: monokai.bgContainer,
            siderBg: monokai.bg,
            bodyBg: monokai.bg
        },
        Menu: {
            itemBg: 'transparent',
            itemSelectedBg: 'rgba(171, 157, 242, 0.16)',
            itemSelectedColor: monokai.purple,
            itemHoverColor: monokai.cyan,
            darkItemBg: monokai.bg,
            darkItemSelectedBg: 'rgba(171, 157, 242, 0.20)',
            darkItemSelectedColor: monokai.purple,
            darkItemHoverColor: monokai.cyan
        },
        Table: {
            headerBg: monokai.bgSubtle,
            headerColor: monokai.textSecondary,
            rowHoverBg: 'rgba(171, 157, 242, 0.08)'
        },
        Button: {
            primaryShadow: 'none'
        },
        Card: {
            colorBgContainer: monokai.bgContainer
        },
        Modal: {
            contentBg: monokai.bgContainer,
            headerBg: monokai.bgContainer
        },
        Drawer: {
            colorBgElevated: monokai.bgContainer
        }
    }
};
